import { makeStyles } from '@mui/styles';
import Switch from 'components/switch';
import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ProjectedPaymentsForm } from '../services';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& .MuiFormControlLabel-label': { marginLeft: theme.spacing(2) },
    '& .MuiSwitch-root:has(.MuiSwitch-switchBase.Mui-focusVisible)': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 0,
      borderRadius: 19,
    },
    '@media (hover: none) and (pointer: coarse)': { minHeight: 44, '& .MuiFormControlLabel-root': { minHeight: 44 } },
  }
}));

type InterestOnlyFieldsProps = {
  methods: UseFormReturn<ProjectedPaymentsForm>
};

const InterestOnlyFields = ({ methods }: InterestOnlyFieldsProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <span className={classes.root}>
      <Controller
        control={methods.control}
        name="interest_only"
        render={({ field }) => (
          <>
            <Switch
              label={t(`projectedPayments:${field.value ? 'interestOnly' : 'no'}`)}
              checked={field.value}
              handleOnChange={(e) => field.onChange(e.target.checked)}
            />
          </>
        )}
      />

    </span>
  );
};

export default InterestOnlyFields;
